/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { EditorPlugins } from '../../types/EditorPlugins';
import {
	requiresCollaborativeFeatureIntegrationPlugin
} from '../requiresCollaborativeFeatureIntegrationPlugin/requiresCollaborativeFeatureIntegrationPlugin';

/* eslint-disable max-len */
const TRACK_CHANGES_INTEGRATION_PLUGIN = `
	/**
	 * The \`TrackChangesIntegration\` lets you synchronize suggestions added to the document with your data source (e.g. a database).
	 *
	 * To read more about it, visit the CKEditor 5 documentation: https://ckeditor.com/docs/ckeditor5/latest/features/collaboration/track-changes/track-changes-integration.html.
	 */
	class TrackChangesIntegration extends Plugin {}
`;
/* eslint-enable max-len */

export function getTrackChangesIntegrationPlugin( editorPlugins: EditorPlugins ): string {
	if ( !requiresCollaborativeFeatureIntegrationPlugin( editorPlugins, 'TrackChanges' ) ) {
		return '';
	}

	return TRACK_CHANGES_INTEGRATION_PLUGIN;
}
